import React from "react";
import MiniTableContainer from "../../common/miniTable/MiniTableContainer";
import {GetAdminContractDashInfoResponseData} from "../../../types/admin";
import {adminContractInfoTableAPI} from "../../../services/admin";
import styles from "./AdminProjectInfoCard.module.css";

interface Column<T> {
    key: keyof T;
    header: string;
    width?: string;
    render?: (value: T) => React.ReactNode;
}

//날짜 요일
const formatDate = (date: Date | undefined, day: number | undefined) => {
    if (!date || day === undefined) return '-';
    const dayOfWeek = ['월', '화', '수', '목', '금', '토', '일'][day - 1];
    return `${date}(${dayOfWeek})`;
};

//작업자 없을 경우 '-' 표기
const formatAmount = (amount: number | undefined) => {
    if (!amount || amount === undefined) return '-';
    return `${amount}명`
}

//컬럼
const contractColumns: Column<GetAdminContractDashInfoResponseData>[] = [
    {
        key: 'companyName',
        header: '회사명',
        width: '16%'
    },
    {
        key: 'startedAt',
        header: '계약일자',
        width: '17%',
        render: (row) => formatDate(row.startedAt, row.startDay)
    },
    {
        key: 'period',
        header: '계약기간',
        width: '10%',
        render: (row) => `${row.period}달`
    },
    {
        key: 'expireAt',
        header: '종료일자',
        width: '17%',
        render: (row) => formatDate(row.expireAt, row.expireDay)
    },
    {
        key: 'workerAmount',
        header: '작업자 수',
        width: '10%',
        render: (row) => formatAmount(row.workerAmount)
    },
    {
        key: 'payday',
        header: '정기 결제일',
        width: '15%',
        render: (row) => `매월 ${row.payday}일`
    },
    {
        key: 'contractStatus',
        header: '계약 상태',
        width: '15%'
    }
];

//어드민 계약 정보 카드
const AdminProjectInfoCard: React.FC = () => {
    //테이블 탭, 다수 생성 가능
    const tabs = [
        {
            id: 'contracts',
            label: '계약 현황',
            //계약 테이블 조회 API
            fetchData: async (page: number) => await adminContractInfoTableAPI(page),
            columns: contractColumns,
        }
    ];

    return (
        //미니 테이블
        <div className={styles.container}>
            {/*미니 테이블*/}
            <MiniTableContainer
                tabs={tabs}
                size="medium"
                itemsPerPage={3}
            />
        </div>
)
    ;
};

export default AdminProjectInfoCard;